import PageTitle from './PageTitle.container'

export default PageTitle
